<script>
import HeaderTop from './HeaderTop';
import HeaderBottom from './HeaderBottom';
import HeaderBottomMobile from './HeaderBottomMobile';
import HeaderMenu from './HeaderMenu';

export default {
  components: {
    HeaderTop,
    HeaderBottom,
    HeaderBottomMobile,
    HeaderMenu,
  },
  props: {
    cart: Object,
    userLoggedIn: Boolean,
    customer: Object,
    search: String,
    marketplaceCategories: Array,
    menuLinks: Array,
    cartRoute: String,
    checkoutRoute: String,
    collapsed: Boolean,
    isMobile: Boolean,
    isMobileSalesPage: Boolean,
    scrollingUp: Boolean,
    hideFixedHeader: Boolean,
    currentScrollTop: Number,
    isWhitelabel: [Boolean, String],
    showHomeLink: [Boolean, String],
  },
  data: () => ({
    menuOpen: false,
    paddingTop: 0,
  }),
  watch: {
    $mq() {
      let sizes = ['sm', 'md'];

      if (this.menuOpen && !sizes.includes(this.$mq)) {
        this.toggleMenu(false);
      }
    },
  },
  methods: {
    toggleMenu(open) {
      this.menuOpen = open;

      this.$store.commit('lockScroll', open);
    },
  },
};
</script>

<template lang='pug'>
header
  header-top(
    v-if='!isMobile && !isWhitelabel',
    ref='headerTop',
    :collapsed='collapsed',
    :customer='customer',
    :user-logged-in='userLoggedIn',
    @navigate='$emit("navigate", $event)',
    @log-out='$emit("log-out", $event)',
  )

  header-bottom-mobile(
    v-if='isMobile',
    :is-whitelabel='isWhitelabel',
    :scrolling-up='scrollingUp',
    :hide-fixed-header='hideFixedHeader',
    :cart-route='cartRoute',
    :checkout-route='checkoutRoute',
    :cart='cart',
    :search='search',
    :marketplace-categories='marketplaceCategories',
    :user-logged-in='userLoggedIn',
    :is-mobile-sales-page='isMobileSalesPage',
    :current-scroll-top='currentScrollTop',
    @search-input='$emit("search-input", $event)',
    @perform-search='$emit("perform-search", $event)',
    @open-menu='toggleMenu(true)',
    @log-out='$emit("log-out", $event)',
  )
    slot(name='logo')

  template(v-else)
    header-bottom(
      ref='headerBottom',
      :is-whitelabel='isWhitelabel',
      :hide-fixed-header='hideFixedHeader',
      :cart-route='cartRoute',
      :checkout-route='checkoutRoute',
      :cart='cart',
      :search='search',
      :marketplace-categories='marketplaceCategories',
      :user-logged-in='userLoggedIn',
      :show-home-link='showHomeLink',
      @search-input='$emit("search-input", $event)',
      @perform-search='$emit("perform-search", $event)',
      @log-out='$emit("log-out", $event)',
    )
      slot(name='logo')
    header-bottom(
      ref='headerBottomFixed',
      fixed,
      :is-whitelabel='isWhitelabel',
      :hide-fixed-header='hideFixedHeader',
      :collapsed='collapsed',
      :cart-route='cartRoute',
      :checkout-route='checkoutRoute',
      :cart='cart',
      :search='search',
      :marketplace-categories='marketplaceCategories',
      :user-logged-in='userLoggedIn',
      :show-home-link='showHomeLink',
      @search-input='$emit("search-input", $event)',
      @perform-search='$emit("perform-search", $event)',
      @log-out='$emit("log-out", $event)',
    )
      slot(name='logo')

  header-menu(
    :open='menuOpen',
    :links='menuLinks',
    :user-logged-in='userLoggedIn',
    :search='search',
    :is-whitelabel='isWhitelabel',
    @close-menu='toggleMenu(false)',
    @navigate='$emit("navigate", $event)',
    @log-out='$emit("log-out", $event)',
    @search-input='$emit("search-input", $event)',
    @perform-search='$emit("perform-search", $event)',
  )
    slot(name='social')
</template>

<style>
@import '~import/index';
</style>